import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { HttpMethods } from 'api/types';
import { AppDispatch } from 'store';
import { setPlusMembershipData } from '../slice';
import { OpPlusV3Info } from '../types';

const fetchPlusMembershipDataOperation = () => async (dispatch: AppDispatch) => {
  const plusMembershipData = await apiRequest<OpPlusV3Info>(
    endpoints.customerOpPlusV3Info,
    {
      isNativeAppRequest: false,
    },
    HttpMethods.GET,
    'data',
  );
  if (plusMembershipData) {
    dispatch(setPlusMembershipData(plusMembershipData));
  }
};

export default fetchPlusMembershipDataOperation;
